import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const LocationPin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 16C13.8 16 12 14.2 12 12C12 9.8 13.8 8 16 8C18.2 8 20 9.8 20 12C20 14.2 18.2 16 16 16ZM16 10C14.9 10 14 10.9 14 12C14 13.1 14.9 14 16 14C17.1 14 18 13.1 18 12C18 10.9 17.1 10 16 10Z" />
		<path d="M16 30C15.787 30 15.562 29.925 15.387 29.788C15.287 29.713 13 27.925 10.699 24.85C7.62402 20.75 5.99902 16.312 5.99902 12C5.99902 6.487 10.486 2 15.999 2C21.512 2 25.999 6.487 25.999 12C25.999 16.312 24.374 20.75 21.299 24.85C18.999 27.925 16.711 29.713 16.611 29.788C16.436 29.925 16.211 30 15.998 30H16ZM16 4C11.588 4 8.00002 7.588 8.00002 12C8.00002 19.9 14.025 25.925 16 27.688C17.975 25.926 24 19.888 24 12C24 7.588 20.413 4 16 4V4Z" />
	</svg>
);

export default LocationPin;
